<template>
  <div id="app">
    <router-view/>
    <a class="wx_kf" href="https://work.weixin.qq.com/kfid/kfc20281554824dbdd4" target="_blank">
      <i class="el-icon-service"></i>
      在线咨询
    </a>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "Microsoft YaHei";
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
.allcontant{
   height: auto;
    min-height: calc(100vh - 200px);
  margin-top: 100px;
      /* height: calc(100vh - 280px); */
}
.router-link-active{
      background: rgba(0,0,0,.15);
  color: #00baff !important;
  border-bottom: 6px solid #00baff;
}
.fuwen{
  cursor: pointer !important;
}
td {
    border: 1px solid;
    padding: 5px;
}

@media screen and (max-width:900px){
  .el-message{
    top:100px !important
  }
}
.wx_kf {
  width: 60px;
  height: 60px;
  color: #FFFFFF;
  background: #18bc9c;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 0;
  bottom: 0;
  text-decoration: none;
  font-size: 12px;
}
.el-icon-service{
    font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue